export default "__VITE_ASSET__d2a2bd18__"